import { render, staticRenderFns } from "./transportation.vue?vue&type=template&id=7257863e&scoped=true"
import script from "./transportation.vue?vue&type=script&lang=js"
export * from "./transportation.vue?vue&type=script&lang=js"
import style0 from "./transportation.vue?vue&type=style&index=0&id=7257863e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257863e",
  null
  
)

export default component.exports